import { FETCH_RTO_FAILURE, FETCH_RTO_REQUEST, FETCH_RTO_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const rtoReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RTO_REQUEST:
            return {
                ...state,
            }
        case FETCH_RTO_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_RTO_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}